import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import reservationFields from "models/lotReservation"
import DateField from "components/DateField"
import fieldStatus from "helpers/fieldStatus"
import NumberField from "components/NumberField"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import _ from "lodash"
import currentUser from "helpers/currentUser"
import settings from "settings"
import getData from "helpers/submitData"
import matchModel from "helpers/matchModel"

class LotReservation extends Component {
	constructor(props) {
		super(props)
		let fields = _.cloneDeep(reservationFields)
		this.state = {
			fields,
			buyer: {},
		}
	}

	componentDidMount() {
		if (_.get(this.props, `data.reserve_start_date`)) {
			getData("mainRetrieve", {
				action: "getBuyerPost",
				id: this.props.data.buyer_id,
			})
				.then((resp) => {
					let fields = _.cloneDeep(reservationFields)
					let f = { ...this.props.data, ...resp.data }
					f = matchModel(fields, f)
					this.setState({ fields: f }, () => {
						//console.log(this.state)
					})
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	validation = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else {
			let shape = {
				//salesperson: Yup.number().required("Required"),
				primary_first: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				primary_last: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				primary_email: settings.requireSaleEmail
					? Yup.string().email("Invalid email address").required("Required")
					: Yup.mixed().notRequired(),
				has_co: Yup.boolean(),
				co_first: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_last: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				reserve_start_date: Yup.number()
					.moreThan(0, "Please enter a reserve start date.")
					.required("Required")
					.typeError("Please enter a reserve start date."),
				reserve_end_date: Yup.number()
					.moreThan(0, "Please enter a reserve end date.")
					.required("Required")
					.typeError("Please enter a reserve end date."),
				//traffic_source: Yup.number().required("Required").typeError("Please enter a value."),
			}
			return Yup.object().shape(shape)
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	coFields = (f) => {
		if (f.values.has_co) {
			return (
				<React.Fragment>
					<li className={fieldStatus("co_first", f)}>
						<label htmlFor="co_first">
							Co-Buyer First Name<sup>*</sup>
						</label>
						{f.errors.co_first && f.touched.co_first && (
							<div className="form__message">{f.errors.co_first}</div>
						)}
						<Field name="co_first" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("co_last", f)}>
						<label htmlFor="co_last">
							Co-Buyer Last Name<sup>*</sup>
						</label>
						{f.errors.co_last && f.touched.co_last && (
							<div className="form__message">{f.errors.co_last}</div>
						)}
						<Field name="co_last" type="text" className="form__input" />
					</li>
				</React.Fragment>
			)
		}
	}

	trafficSources = () => {
		return _.map(this.props.payload.public.trafficSources, (v) => {
			return { value: v.id, label: v.name }
		})
	}

	spOptions = () => {
		let user = currentUser()
		let sps = []
		let d = this.props.super ? this.props.data.lot : this.props.data
		_.forEach(this.props.payload.public.salespeople, (v) => {
			if (this.props.super || user.viewAs) {
				if (v.builders.includes(d.builder) && v.properties.includes(d.property)) {
					sps.push({
						label: `${v.first} ${v.last}`,
						value: v.id,
					})
				}
			} else {
				if (v.builders.includes(d.builder) && v.properties.includes(d.property) && v.status == 1) {
					sps.push({
						label: `${v.first} ${v.last}`,
						value: v.id,
					})
				}
			}
		})
		return sps
	}

	cancelReservation = () => {
		let values = {}
		values.lot_id = this.props.data.id
		values.action = "manageLotReservation"
		values.type = "cancel"
		submitData("mainIngest", values)
			.then((data) => {
				this.props.notify(data, this.props.name)
			})
			.catch((e) => {
				this.props.notify(e, this.props.name)
			})
	}

	formLayout = (f) => {
		return (
			<div>
				{console.log(f)}
				<div className="flex justify-end">
					<p className="text-sm text-red-500 cursor-pointer" onClick={() => this.cancelReservation()}>
						<i className="far fa-ban mr-1" />
						Cancel Reservation
					</p>
				</div>
				<Form>
					<ul className="form__list">
						{/* <li className={fieldStatus("salesperson", f)}>
							<label htmlFor="salesperson">
								Salesperson<sup>*</sup>
							</label>
							{f.errors.salesperson && f.touched.salesperson && (
								<div className="form__message">{f.errors.salesperson}</div>
							)}
							<ReactSelect
								name={`salesperson`}
								options={this.spOptions()}
								value={f.values.salesperson}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
								clearable={true}
							/>
						</li> */}
						<li className={fieldStatus("primary_first", f)}>
							<label htmlFor="primary_first">
								Buyer First Name<sup>*</sup>
							</label>
							{f.errors.primary_first && f.touched.primary_first && (
								<div className="form__message">{f.errors.primary_first}</div>
							)}
							<Field name="primary_first" type="text" className="form__input" />
						</li>
						<li className={fieldStatus("primary_last", f)}>
							<label htmlFor="primary_last">
								Buyer Last Name<sup>*</sup>
							</label>
							{f.errors.primary_last && f.touched.primary_last && (
								<div className="form__message">{f.errors.primary_last}</div>
							)}
							<Field name="primary_last" type="text" className="form__input" />
						</li>
						<li className={fieldStatus("primary_email", f)}>
							<label htmlFor="primary_email">
								Buyer Email<sup>*</sup>
							</label>
							{f.errors.primary_email && f.touched.primary_email && (
								<div className="form__message">{f.errors.primary_email}</div>
							)}
							<Field name="primary_email" type="email" className="form__input" />
						</li>
						<li className={fieldStatus("has_co", f)}>
							<label htmlFor="has_co">Has Co-Buyer?</label>
							{f.errors.has_co && f.touched.has_co && (
								<div className="form__message">{f.errors.has_co}</div>
							)}
							<Field
								name="has_co"
								type="checkbox"
								className="form__input"
								onChange={(event) => f.setFieldValue("has_co", event.target.checked)}
								checked={f.values.has_co}
							/>
						</li>
						{this.coFields(f)}
						<li className={fieldStatus("reserve_start_date", f)}>
							<label htmlFor="reserve_start_date">
								Reserve Start Date<sup>*</sup>
							</label>
							{f.errors.reserve_start_date && f.touched.reserve_start_date && (
								<div className="form__message">{f.errors.reserve_start_date}</div>
							)}
							<DateField
								name="reserve_start_date"
								className="form__textarea"
								value={f.values.reserve_start_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.reserve_start_date}
								error={f.errors.reserve_start_date}
							/>
						</li>
						<li className={fieldStatus("reserve_end_date", f)}>
							<label htmlFor="reserve_end_date">
								Reserve End Date <sup>*</sup>
							</label>
							{f.errors.reserve_end_date && f.touched.reserve_end_date && (
								<div className="form__message">{f.errors.reserve_end_date}</div>
							)}
							<DateField
								name="reserve_end_date"
								className="form__textarea"
								value={f.values.reserve_end_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.reserve_end_date}
								error={f.errors.reserve_end_date}
							/>
						</li>
						{/* <li className={fieldStatus("traffic_source", f)}>
							<label htmlFor="traffic_source">
								Traffic Source <sup>*</sup>
							</label>
							{f.errors.traffic_source && f.touched.traffic_source && (
								<div className="form__message">{f.errors.traffic_source}</div>
							)}
							<ReactSelect
								name={`traffic_source`}
								options={this.trafficSources()}
								value={f.values.traffic_source}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li> */}
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		let action = this.state.fields.buyer_id ? "Modify" : "Add"
		return (
			<div className="modal">
				<h3>
					{action} Lot Reservation: {this.props.data.address}
				</h3>
				<Formik
					initialValues={this.state.fields}
					validateOnMount={true}
					validationSchema={this.validation}
					enableReinitialize
					onSubmit={(values) => {
						this.props.loadingStatus(true)
						// On the super side with adding this
						if (this.props.super) {
							values.lot_id = this.props.data.lot.id
						} else {
							// On the salesperson side
							values.lot_id = this.props.data.id
						}
						values.action = "manageLotReservation"
						submitData("mainIngest", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
								this.props.loadingStatus(false)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
								this.props.loadingStatus(false)
							})
					}}>
					{(f) => this.formLayout(f)}
				</Formik>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotReservation)
